import { CURRENT_CONFIG } from '/@/api/http/config'

export const MapTypes = {
  OSM: {
    name: 'OpenStreetMap',
    tileServer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap contributors'
  },
  VOYAGER: {
    name: 'Street (EN)',
    tileServer: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    attribution: '© OpenStreetMap contributors, © CARTO'
  },
  SATELLITE: {
    name: 'Satellite',
    tileServer: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '© Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  },
  TERRAIN: {
    name: 'Terrain',
    tileServer: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '© OpenTopoMap contributors'
  },
  DARK: {
    name: 'Dark',
    tileServer: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution: '© CartoDB'
  }
}

export const OSMConfig = {
  // Default tile server (OpenStreetMap)
  tileServer: CURRENT_CONFIG.osmTileServer || MapTypes.VOYAGER.tileServer,
  attribution: CURRENT_CONFIG.osmAttribution || MapTypes.VOYAGER.attribution,

  // Default center and zoom - India
  defaultCenter: [22.9734, 78.6569] as [number, number],
  defaultZoom: 5
}
